<template>
  <div
    v-if="moduleData"
    class="module-options"
  >
    <ShapeBorderOptions
      :canvas-name="canvasName"
      :module-data="moduleData"
    />
  </div>
</template>

<script>
import ShapeBorderOptions from '@/components/modules/ShapeBorderOptions.vue';

export default {
  name: 'PlaceholderModuleOptions',
  components: {
    ShapeBorderOptions,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
};
</script>
